var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20",
    "data-name": "Group 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.375,
    viewBox: "0 0 30 29.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M15,5.329A15.069,15.069,0,0,0,10.26,34.678c.75.139,1.024-.326,1.024-.726,0-.358-.013-1.305-.021-2.561C7.091,32.3,6.21,29.372,6.21,29.372a3.977,3.977,0,0,0-1.665-2.2c-1.363-.934.1-.915.1-.915a3.15,3.15,0,0,1,2.3,1.552,3.188,3.188,0,0,0,4.367,1.251,3.215,3.215,0,0,1,.952-2.014C8.932,26.663,5.43,25.371,5.43,19.6a5.837,5.837,0,0,1,1.545-4.042,5.427,5.427,0,0,1,.146-3.984s1.26-.405,4.125,1.543a14.158,14.158,0,0,1,7.511,0c2.863-1.948,4.121-1.543,4.121-1.543a5.435,5.435,0,0,1,.15,3.984A5.826,5.826,0,0,1,24.57,19.6c0,5.784-3.506,7.057-6.847,7.431a3.6,3.6,0,0,1,1.018,2.788c0,2.014-.019,3.638-.019,4.131,0,.4.27.872,1.031.724A15.07,15.07,0,0,0,15,5.329Z",
    transform: "translate(0 -5.329)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.eec10ede.svg";
export { ForwardRef as ReactComponent };